import { render, staticRenderFns } from "./heart-config.vue?vue&type=template&id=a47d273a&"
import script from "./heart-config.vue?vue&type=script&lang=js&"
export * from "./heart-config.vue?vue&type=script&lang=js&"
import style0 from "./heart-config.vue?vue&type=style&index=0&lang=css&"
import style1 from "./heart-config.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports